import React, { Component } from 'react';
import LoadingBar from 'react-top-loading-bar';

class Loading extends Component {
  static defaultProps = {
    loading: false,
  };

  state = {
    progress: 0,
  };

  componentDidUpdate(oldProps) {
    const { loading } = this.props;

    if (oldProps.loading && !loading) {
      this.setState({ progress: 100 });
    }
  }

  render() {
    const { progress } = this.state;

    return (
      <LoadingBar
        progress={progress}
        height={3}
        color="#6C0CAE"
      />
    );
  }
}

export default Loading;
